class PushCartOrderDeadline extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const externalOrderDeadline = document.querySelector(
      '[data-push-cart-order-deadline-external-el="globalMessage"]',
    )

    const activeShop = window.Shopify.shop

    if (activeShop !== 'oh-polly-uk.myshopify.com') return

    window.BAO.geoLocationPromise.finally(() => {
      const customerCountryCode = window.theme.customer.countryCode

      if (customerCountryCode !== 'GB') {
        this.setAttribute('hidden', '')
      }
    })

    if (!externalOrderDeadline) return

    this.mutationObserver = new MutationObserver(() => {
      this.injectOrderDeadline(externalOrderDeadline)
    })

    const placementTarget = externalOrderDeadline.querySelector(
      '[data-placement-target]',
    )

    if (
      placementTarget &&
      Array.from(placementTarget.childNodes).some(
        node => node.nodeType === 1 && node.tagName === 'DIV',
      )
    ) {
      this.injectOrderDeadline(externalOrderDeadline)
    } else {
      // Watch the externalOrderDeadline for changes
      this.mutationObserver.observe(externalOrderDeadline, {
        childList: true,
        subtree: true,
      })

      // Initial injection attempt
      this.injectOrderDeadline(externalOrderDeadline)

      // Clean up after 5 seconds to allow content to stabilize
      setTimeout(() => {
        this.mutationObserver.disconnect()
        this.disconnect()
      }, 5000)
    }
  }

  injectOrderDeadline (externalOrderDeadline) {
    this.innerHTML = ''
    const clonedExternalOrderDeadline = externalOrderDeadline.cloneNode(true)
    this.appendChild(clonedExternalOrderDeadline)
  }

  disconnectedCallback () {
    super.disconnectedCallback()
  }
}

customElements.define('push-cart-order-deadline', PushCartOrderDeadline)
